import React from 'react'
import Manager from '../../public/components/Manager'
import LeaveApplyDetail from './LeaveApplyDetail'
import LeaveApplyBatchDiv from '../../business/LeaveApplyBatchDiv'
import { reconfigButton, nullDate, TDate, getListFromValues } from '../../../src/public/utility'

Ext.require('Ext.Toast')
const disableBatch = ({ state: { selected = null } }) => !selected || !selected.length

const config = () => {
	const handelBatchAction = ({ showDetail, refreshPage, state: { selected }, props: { dispatch } }, title) => {
		const list = selected && selected.map(o => o.data.id) || []
		Tyan.pubForm.showDialog(title, props => <LeaveApplyBatchDiv {...props} ids={list} action={title} onSave={refreshPage} />)
	}
	const tiptools = [{
		_tool: '', icon: 'info-circle', ui: 'action', tooltip: o => (
			`
            员工编号:${o['员工编号']}<br>
            员工姓名:${o['员工姓名']}<br>
            部门名称:${o['部门名称']}<br>
            职务名称:${o['职务名称']}<br>
            职务代理人:${o['职务代理人']}<br>
            假勤项目:${o['假勤项目']}<br>
            请假时间:${o['开始时间'] && o['开始时间'] != nullDate && new TDate(o['开始时间']).toString('yyyy/MM/dd HH:mm') || ''}~
            ${o['结束时间'] && o['结束时间'] != nullDate && new TDate(o['结束时间']).toString('yyyy/MM/dd HH:mm') || ''}<br>
            服务单位:${o['服务单位']}<br>
            是否产生误餐费:${o['是否产生误餐费']}<br>
            出行方式:${o['出行方式']}<br>
            请假原因:${o['请假原因']}<br>
            任务交接说明:${o['任务交接说明']}<br>
            备注:${o['备注']}<br>
            `
		)
	}]
	return {
		multiSelect: true,
		buttons: [
			{
				text: '确定', handler: that => handelBatchAction(that, '提交'), disabled: disableBatch
			},
			{
				text: '驳回', handler: that => handelBatchAction(that, '驳回'), disabled: disableBatch
			},
		],
		columns: [
			{ _text: '申请编号', minWidth: 250, search: true, tools: tiptools },
			{ _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
			{ _datetime: '开始时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
			{ _datetime: '结束时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
			{ _text: '申请人', minWidth: 150, search: true, },
			{ _: '职务代理人', },
			{ _: '员工编号', field: 'Person.PersonNo' },
			{ _: '员工姓名', field: 'Person.ActualName' },
			{ _: '部门名称', field: 'Person.Dep.ShortName' },
			{ _: '职务名称', field: 'Person.PersonDuty' },
			{ _: '假勤项目', field: 'OutReason' },
			{ _: '服务单位', field: 'ServiceUnit' },
			{ _: '是否产生误餐费', field: 'DelayMealFee' },
			{ _: '出行方式', field: 'OutMode' },
			{ _: '任务交接说明', field: 'TaskTransferInstructions' },
			{ _: '请假原因', field: 'OutIllustrate' },
			{ _: '备注', field: 'Remark' },
			{ _: 'taskName', field: '_TaskName' }
		],
		onDoubleTap: ({ showDetail, refreshPage }, data) => {
			showDetail(props => <LeaveApplyDetail {...props} id={data.id} taskName={data.taskName} />)
		}
	}
}
export default props => <Manager {...props} config={config} />